import { isGenerallyAvailableBeta } from "./beta-ga";

/** Administrative controls only; never changes the hard-off enforcement list. */
export const RETIRED_BETA_KEYS: readonly string[] = [
  "collections", "trash-service", "trash_service", "acquisitions",
  "buy", "renovations", "sell", "property_launch",
];

export const STALE_BETA_KEYS: readonly string[] = [
  "mercury_balances", "mercury_statements", "telegram", "telegram_channel",
];

export function isBetaCatalogKey(key: string): boolean {
  return !RETIRED_BETA_KEYS.includes(key) && !STALE_BETA_KEYS.includes(key)
    && !isGenerallyAvailableBeta(key) && key !== "ai_drafting";
}

export function isAdminGateKey(key: string): boolean {
  return !RETIRED_BETA_KEYS.includes(key);
}

export const AUTO_DRAFT_DESCRIPTION = "AI drafts replies to eligible member messages. Auto-send is off by default and only runs when configured, subject to safety checks and quiet hours.";
export const PULSE_BRIEFING_DESCRIPTION = "AI briefing on Home covering portfolio performance and operational priorities; requires both beta access and the applicable plan.";
